import React from 'react';
import { cn } from '../../lib/utils';

const BADGE_STYLES = {
  incomplete: 'border border-dashed border-amber-400 bg-transparent text-amber-800',
  high_confidence: 'border border-emerald-200 bg-emerald-50 text-emerald-800',
};

const BADGE_LABELS = {
  incomplete: 'incomplete',
  high_confidence: 'high confidence',
};

export function StatusBadge({ tone, className }) {
  if (!tone || !BADGE_STYLES[tone]) return null;
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-semibold',
        BADGE_STYLES[tone],
        className
      )}
    >
      {BADGE_LABELS[tone]}
    </span>
  );
}
